import React, { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import ApproveTimeOffForm from "features/timesheet/manage-time-off/ApproveTimeOffForm";
import { DrawerContextProvider } from "shared/contexts/DrawerContext";
import ManageTimeOffContext from "features/timesheet/contexts/ManageTimeOffContext";
import ManageTimeOffTable from "features/timesheet/manage-time-off/ManageTimeOffTable";
import Modal from "shared/components/feedback/modals/MasterModal";
import RejectTimeOffForm from "features/timesheet/manage-time-off/RejectTimeOffForm";
import SessionContext from "app/contexts/SessionContext";
import VStack from "shared/components/layout/stack/VStack";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const action = searchParams.get("action");
    const id = searchParams.get("id");
    const {
        setRejectActionFromMenu,
        isManageViewRequest,
        setIsManageViewRequest,
    } = useContext(ManageTimeOffContext);

    const onClose = () => {
        setRejectActionFromMenu(false);
        setIsManageViewRequest(false);
        navigate(".", { replace: true });
    };

    const parsedId = Number.parseInt(id);

    if (action === "viewRequest" && !Number.isNaN(parsedId)) {
        return (
            <Modal
                title={
                    isManageViewRequest
                        ? "Time Off Request"
                        : "Review Time Off Request"
                }
                stickyAction={true}
                onRequestClose={onClose}
            >
                <ApproveTimeOffForm
                    timeOffRequestId={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    if (action === "rejectRequest" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Review Time Off Request" onRequestClose={onClose}>
                <RejectTimeOffForm
                    timeOffRequestId={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const ManageTimeOff = () => {
    const session = useContext(SessionContext);
    
    if (session.freelancer || session.contractor){
        globalThis.location.replace("/timesheets/");
    }
    return (
        <VStack>
            <FormPresenter />
            <DrawerContextProvider>
                <ManageTimeOffTable />
            </DrawerContextProvider>
        </VStack>
    );
};

export default ManageTimeOff;
